import { SCHEMA_VERSION, TABLES, DEMO_IDS } from "./schema";
import { migrateJourneyDb } from "./migrate";
import { seedJourneyDemo } from "./seed";
import { seedDemoCredentials } from "./credentials";
import {
  getSnapshot,
  getById,
  listTable,
  insertRow,
  updateRow,
  upsertRow,
  rowsFromIndex,
  idsFromIndex,
  writeAudit,
  invalidateDbCache,
  putBlob,
  getBlob,
} from "./engine";

let ready = false;

export function ensureJourneyDb() {
  if (!ready) {
    migrateJourneyDb();
    seedJourneyDemo();
    seedDemoCredentials();
    ready = true;
  }
  return getSnapshot();
}

export function resetJourneyDbCache() {
  ready = false;
  invalidateDbCache();
}

export {
  SCHEMA_VERSION,
  TABLES,
  DEMO_IDS,
  getSnapshot,
  getById,
  listTable,
  insertRow,
  updateRow,
  upsertRow,
  rowsFromIndex,
  idsFromIndex,
  writeAudit,
  putBlob,
  getBlob,
};

export function messagesForThread(threadId) {
  ensureJourneyDb();
  return rowsFromIndex("messages", "messagesByThreadId", threadId);
}

export function threadsForTransaction(transactionId) {
  ensureJourneyDb();
  return rowsFromIndex("message_threads", "threadsByTransactionId", transactionId);
}

export function transactionsForAgent(agentId) {
  ensureJourneyDb();
  if (!agentId) return listTable("transactions");
  return rowsFromIndex("transactions", "transactionsByAgentId", agentId);
}

export function transactionsForClient(clientId) {
  ensureJourneyDb();
  return rowsFromIndex("transactions", "transactionsByClientId", clientId);
}

export function transactionsForBroker(brokerId) {
  ensureJourneyDb();
  if (!brokerId) return listTable("transactions");
  return rowsFromIndex("transactions", "transactionsByBrokerId", brokerId);
}

export function getUserByEmail(email) {
  ensureJourneyDb();
  const key = String(email || "").toLowerCase();
  return getSnapshot().indexes.usersByEmail.get(key) || null;
}
